import { render } from "./inquiryMainForm.vue?vue&type=template&id=15990c15&scoped=true"
import script from "./inquiryMainForm.vue?vue&type=script&lang=js"
export * from "./inquiryMainForm.vue?vue&type=script&lang=js"

import "./inquiryMainForm.vue?vue&type=style&index=0&id=15990c15&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15990c15"]])

export default __exports__